/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Japanese
export default {
  'editor-common-extensibility-extension-lozenge-editToggle.done.editing': '編集を完了',
  'editor-common-extensibility-extension-lozenge-editToggle.make.edits': '編集',
  'editor-common-extensibility.macro.button.configure': '{macroName} を構成',
  'editor.extension.legacyContentHeader': 'レガシー コンテンツ',
  'editor.extension.legacyContentHeader.contentHasLimitedFunctionality': 'このコンテンツは機能が制限されています。',
  'editor.extension.legacyContentHeader.learnMore': '詳細',
  'editor.trackChanges.toolbarIconLabel': '変更を追跡',
  'fablric.editor.viewAllInserts': 'すべての挿入アイテムを表示',
  'fabric.editor.action': 'アクション アイテム',
  'fabric.editor.action.description': 'アクション アイテムを作成して割り当て',
  'fabric.editor.addAltText': '代替テキスト',
  'fabric.editor.addColumnLeft': '左に列を追加',
  'fabric.editor.addColumnRight': '右に列を追加',
  'fabric.editor.addCommentOnMedia': 'コメントを追加',
  'fabric.editor.addImageBorder': '枠を追加',
  'fabric.editor.addLoomVideo': 'Loom 動画を録画する',
  'fabric.editor.addLoomVideoComment': 'Loom 動画のコメントを記録',
  'fabric.editor.addMediaFiles': '画像、動画、またはファイルを追加',
  'fabric.editor.addRowAbove': '上に行を追加',
  'fabric.editor.addRowBelow': '下に行を追加',
  'fabric.editor.addUpdatedAltText': '代替テキストを追加',
  'fabric.editor.ai.ai-panels.actionItemsPageDescription':
    'Atlassian Intelligence を使用してアクション アイテムを検索し、パネルに表示します',
  'fabric.editor.ai.ai-panels.actionItemsPageTitle': 'アクション アイテム パネル (ベータ版)',
  'fabric.editor.ai.ai-panels.summarizePageDescription':
    'Atlassian Intelligence を使用してこのページを要約し、パネルに表示します',
  'fabric.editor.ai.ai-panels.summarizePageTitle': 'ページ要約パネル (ベータ版)',
  'fabric.editor.ai.ai-smart-button.context.reference': '選択したコンテンツのみ',
  'fabric.editor.ai.atlas-prebuilt.atlasGenerateContentConfigItemDescription':
    'アップデートに挿入するコンテンツを生成します',
  'fabric.editor.ai.atlas-prebuilt.atlasSummarizePageConfigItemDescription': '最新情報を要約します',
  'fabric.editor.ai.commandPalette.promptBuilderForm.buttons.submit': '生成',
  'fabric.editor.ai.commandPalette.promptBuilderForm.generateContent.ariaLabel': 'Atlassian Intelligence に質問する',
  'fabric.editor.ai.config.item.action.edit': '編集',
  'fabric.editor.ai.config.item.action.insert': '挿入',
  'fabric.editor.ai.config.item.action.insertAtTop': '最上部に挿入',
  'fabric.editor.ai.config.item.action.insertBelow': '下に挿入',
  'fabric.editor.ai.config.item.action.insertBelowOriginal': '元のコンテンツの下に挿入',
  'fabric.editor.ai.config.item.action.replace': '置換',
  'fabric.editor.ai.config.item.action.replaceTitle': 'タイトルを置換',
  'fabric.editor.ai.config.item.action.replaceTitleTooLongDisabledTooltip':
    'タイトルは {maxLength} 文字以内で入力してください',
  'fabric.editor.ai.config.item.action.rovoAgents.contineChatLabel': 'チャットで続行',
  'fabric.editor.ai.config.item.action.rovoAgents.continueInChatLabel': 'チャットで開く',
  'fabric.editor.ai.config.item.addPolish.description': 'コンテンツに磨きをかけて、より洗練されたものにします',
  'fabric.editor.ai.config.item.addPolish.title': 'コンテンツに磨きをかけます',
  'fabric.editor.ai.config.item.agent.title': 'Atlassian Intelligence Rovo エージェント',
  'fabric.editor.ai.config.item.atlas-shorten-update.description': 'コンテンツをより簡潔なものにします',
  'fabric.editor.ai.config.item.atlas-shorten-update.title': '情報を要約',
  'fabric.editor.ai.config.item.bb.pr.description.description': '変更の要約を含むプル リクエストの説明を作成します',
  'fabric.editor.ai.config.item.bb.pr.description.title': 'プル リクエストの説明を作成する',
  'fabric.editor.ai.config.item.brainstorm.description': '指定されたトピックに関するアイデアのリストを生成します',
  'fabric.editor.ai.config.item.brainstorm.promptHint': 'トピックをご入力ください...',
  'fabric.editor.ai.config.item.brainstorm.promptLabel': 'ブレーンストーミング',
  'fabric.editor.ai.config.item.brainstorm.title': 'ブレーンストーミング',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentShortTitle': '所要時間',
  'fabric.editor.ai.config.item.changeTone.adjustLengthNestingParentTitle': '長さを調整',
  'fabric.editor.ai.config.item.changeTone.casualTone.description': 'コンテンツのトーンをカジュアルなものに変更します',
  'fabric.editor.ai.config.item.changeTone.casualTone.selectionToolbar.dropdownItem.title': 'カジュアル',
  'fabric.editor.ai.config.item.changeTone.casualTone.shortTitle': 'カジュアル',
  'fabric.editor.ai.config.item.changeTone.casualTone.title': 'カジュアルなトーンに変更',
  'fabric.editor.ai.config.item.changeTone.educationalTone.description': 'コンテンツのトーンを教育的なものに変更します',
  'fabric.editor.ai.config.item.changeTone.educationalTone.selectionToolbar.dropdownItem.title': '教育的',
  'fabric.editor.ai.config.item.changeTone.educationalTone.shortTitle': '教育的',
  'fabric.editor.ai.config.item.changeTone.educationalTone.title': '教育的なトーンに変更',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.description': 'コンテンツのトーンを共感的なものに変更します',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.selectionToolbar.dropdownItem.title': '共感的',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.shortTitle': '共感的',
  'fabric.editor.ai.config.item.changeTone.empatheticTone.title': '共感的なトーンに変更',
  'fabric.editor.ai.config.item.changeTone.nestingParentTitlePostGA': 'トーンを次に変更',
  'fabric.editor.ai.config.item.changeTone.neutralTone.description': 'コンテンツのトーンを中立的なものに変更します',
  'fabric.editor.ai.config.item.changeTone.neutralTone.selectionToolbar.dropdownItem.title': '中立的',
  'fabric.editor.ai.config.item.changeTone.neutralTone.shortTitle': '中立的',
  'fabric.editor.ai.config.item.changeTone.neutralTone.title': '中立的なトーンに変更',
  'fabric.editor.ai.config.item.changeTone.professionalTone.description':
    'コンテンツのトーンを職務的なものに変更します',
  'fabric.editor.ai.config.item.changeTone.professionalTone.selectionToolbar.dropdownItem.title': '職務的',
  'fabric.editor.ai.config.item.changeTone.professionalTone.shortTitle': '職務的',
  'fabric.editor.ai.config.item.changeTone.professionalTone.title': '職務的なトーンに変更',
  'fabric.editor.ai.config.item.convertToBulletList.description': 'コンテンツを箇条書きリストに再フォーマットします',
  'fabric.editor.ai.config.item.convertToBulletList.title': '箇条書きリストに変換',
  'fabric.editor.ai.config.item.convertToTable.description': 'コンテンツを見出し付きの表に再フォーマットします',
  'fabric.editor.ai.config.item.convertToTable.title': '表に変換',
  'fabric.editor.ai.config.item.draftReply.description':
    'あなたが取り組んでいる課題に類似する課題に基づいて返信の下書きを作成します',
  'fabric.editor.ai.config.item.draftReply.title': '返信の下書きを作成する',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.description': 'スペルと文法のミスを修正します',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.selectionToolbar.dropdownItem.title': 'スペルと文法',
  'fabric.editor.ai.config.item.enhance.fixSpellingGrammar.title': 'スペルと文法を修正',
  'fabric.editor.ai.config.item.enhance.improveWriting.description':
    'エンゲージメントと理解を促進するため、明瞭さ、構成、トーンを改善します',
  'fabric.editor.ai.config.item.enhance.improveWriting.selectionToolbar.dropdownItem.title': '文章を改善する',
  'fabric.editor.ai.config.item.enhance.improveWriting.title': '文章を改善',
  'fabric.editor.ai.config.item.findActionItems.description': '指定されたコンテンツ内のアクション アイテムを見つけます',
  'fabric.editor.ai.config.item.findActionItems.title': 'アクション アイテムを探す',
  'fabric.editor.ai.config.item.freeGenerate.disabled.promptHint':
    '以下から選択してください (自由形式の生成は現在 Elevate で無効になっています)',
  'fabric.editor.ai.config.item.generateContent.promptHint': 'AI で文章を作成するか、次から選択してください',
  'fabric.editor.ai.config.item.generateContent.rovoPromptHint': 'Rovo で文章を作成するか、次から選択してください',
  'fabric.editor.ai.config.item.generateEscalationNotes.description':
    '課題のコンテキストに基づいてエスカレーションのメモを生成できます',
  'fabric.editor.ai.config.item.generateEscalationNotes.title': 'エスカレーションのメモを生成する',
  'fabric.editor.ai.config.item.improveDescription.default.description': '課題タイプに基づいて課題の説明を再構築します',
  'fabric.editor.ai.config.item.improveDescription.default.title.experiment.one': '説明を改善',
  'fabric.editor.ai.config.item.makeLonger.description': 'あなたが提供したコンテキストに基づいてコンテンツを拡張します',
  'fabric.editor.ai.config.item.makeLonger.title': 'もっと長くする',
  'fabric.editor.ai.config.item.range.agent.description': '説明がありません',
  'fabric.editor.ai.config.item.range.agent.prompt.hint':
    '何か書き込むようにエージェントに指示するか、以下から選択してください',
  'fabric.editor.ai.config.item.rephrase.description': '文章を書き直すための候補を作成します',
  'fabric.editor.ai.config.item.rephrase.title': '言い換える',
  'fabric.editor.ai.config.item.shorten.description': 'コンテンツをより簡潔なものにします',
  'fabric.editor.ai.config.item.shorten.selectionToolbar.dropdownItem.title': '短縮',
  'fabric.editor.ai.config.item.shorten.title': '短縮',
  'fabric.editor.ai.config.item.suggest.description': '指定されたコンテンツのタイトルを提案します',
  'fabric.editor.ai.config.item.suggest.title': 'タイトルを提案',
  'fabric.editor.ai.config.item.summarize.description': '作業中のテキストの要約を作成し、重要なポイントを強調します',
  'fabric.editor.ai.config.item.summarize.dropdownItem.title': '文章を要約する',
  'fabric.editor.ai.config.item.summarize.title': '文章を要約',
  'fabric.editor.ai.config.item.translate.czech': 'チェコ語',
  'fabric.editor.ai.config.item.translate.danish': 'デンマーク語',
  'fabric.editor.ai.config.item.translate.dutch': 'オランダ語',
  'fabric.editor.ai.config.item.translate.english': '英語',
  'fabric.editor.ai.config.item.translate.finnish': 'フィンランド語',
  'fabric.editor.ai.config.item.translate.french': 'フランス語',
  'fabric.editor.ai.config.item.translate.german': 'ドイツ語',
  'fabric.editor.ai.config.item.translate.hungarian': 'ハンガリー語',
  'fabric.editor.ai.config.item.translate.italian': 'イタリア語',
  'fabric.editor.ai.config.item.translate.japanese': '日本語',
  'fabric.editor.ai.config.item.translate.nestingParentTitle.ga': '翻訳',
  'fabric.editor.ai.config.item.translate.nestingParentTitlePostGA': '次に翻訳',
  'fabric.editor.ai.config.item.translate.norwegian': 'ノルウェー語',
  'fabric.editor.ai.config.item.translate.russian': 'ロシア語',
  'fabric.editor.ai.config.item.translate.spanish': 'スペイン語',
  'fabric.editor.ai.config.item.translate.swedish': 'スウェーデン語',
  'fabric.editor.ai.config.item.translate.thai': 'タイ語',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.description':
    '作業中のテキストを中国語 (簡体字) に翻訳します',
  'fabric.editor.ai.config.item.translateTo.chineseSimplified.title': '中国語 (簡体字) に翻訳',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.description':
    '作業中のテキストを中国語 (繁体字) に翻訳します',
  'fabric.editor.ai.config.item.translateTo.chineseTraditional.title': '中国語 (繁体字) に翻訳',
  'fabric.editor.ai.config.item.translateTo.czech.description': '作業中のテキストをチェコ語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.czech.title': 'チェコ語に翻訳',
  'fabric.editor.ai.config.item.translateTo.danish.description': '作業中のテキストをデンマーク語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.danish.title': 'デンマーク語に翻訳',
  'fabric.editor.ai.config.item.translateTo.dutch.description': '作業中のテキストをオランダ語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.dutch.title': 'オランダ語に翻訳',
  'fabric.editor.ai.config.item.translateTo.english.description': '作業中のテキストを英語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.english.title': '英語に翻訳',
  'fabric.editor.ai.config.item.translateTo.finnish.description': '作業中のテキストをフィンランド語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.finnish.title': 'フィンランド語に翻訳',
  'fabric.editor.ai.config.item.translateTo.french.description': '作業中のテキストをフランス語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.french.title': 'フランス語に翻訳',
  'fabric.editor.ai.config.item.translateTo.german.description': '作業中のテキストをドイツ語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.german.title': 'ドイツ語に翻訳',
  'fabric.editor.ai.config.item.translateTo.hungarian.description': '作業中のテキストをハンガリー語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.hungarian.title': 'ハンガリー語に翻訳',
  'fabric.editor.ai.config.item.translateTo.italian.description': '作業中のテキストをイタリア語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.italian.title': 'イタリア語に翻訳',
  'fabric.editor.ai.config.item.translateTo.japanese.description': '作業中のテキストを日本語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.japanese.title': '日本語に翻訳',
  'fabric.editor.ai.config.item.translateTo.korean.description': '作業中のテキストを韓国語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.korean.title': '韓国語に翻訳',
  'fabric.editor.ai.config.item.translateTo.norwegian.description': '作業中のテキストをノルウェー語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.norwegian.title': 'ノルウェー語に翻訳',
  'fabric.editor.ai.config.item.translateTo.polish.description': '作業中のテキストをポーランド語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.polish.title': 'ポーランド語に翻訳',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.description':
    '作業中のテキストをポルトガル語 (ブラジル) に翻訳します',
  'fabric.editor.ai.config.item.translateTo.portugueseBrazilian.title': 'ポルトガル語 (ブラジル) に翻訳',
  'fabric.editor.ai.config.item.translateTo.russian.description': '作業中のテキストをロシア語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.russian.title': 'ロシア語に翻訳',
  'fabric.editor.ai.config.item.translateTo.spanish.description': '作業中のテキストをスペイン語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.spanish.title': 'スペイン語に翻訳',
  'fabric.editor.ai.config.item.translateTo.swedish.description': '作業中のテキストをスウェーデン語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.swedish.title': 'スウェーデン語に翻訳',
  'fabric.editor.ai.config.item.translateTo.thai.description': '作業中のテキストをタイ語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.thai.title': 'タイ語に翻訳',
  'fabric.editor.ai.config.item.translateTo.turkish.description': '作業中のテキストをトルコ語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.turkish.title': 'トルコ語に翻訳',
  'fabric.editor.ai.config.item.translateTo.ukrainian.description': '作業中のテキストをウクライナ語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.ukrainian.title': 'ウクライナ語に翻訳',
  'fabric.editor.ai.config.item.translateTo.vietnamese.description': '作業中のテキストをベトナム語に翻訳します',
  'fabric.editor.ai.config.item.translateTo.vietnamese.title': 'ベトナム語に翻訳',
  'fabric.editor.ai.confluence-prebuilt.confluenceChangeToneSelectionToolbarDropdownMenuTitle': 'トーンを変更',
  'fabric.editor.ai.confluence-prebuilt.confluenceRewriteSelectionToolbarDropdownMenuTitle': '書き換え',
  'fabric.editor.ai.confluence-prebuilt.confluenceTranslateSelectionToolbarDropdownMenuTitle': '翻訳',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitle': 'ページ タイトル',
  'fabric.editor.ai.eventHub.fallbackSuggestedTitlePrefix': 'ページ',
  'fabric.editor.ai.experience-application.cmdPaletteUnhandledErrorMessage':
    '問題が発生しているため、現在応答を生成できません。しばらくしてからもう一度お試しください。',
  'fabric.editor.ai.experience-application.documentInsertError':
    '返信を挿入する際に問題が発生しました。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.experience-application.error-boundary.markdownErrorMessage':
    'プレビューを生成できません。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.experience-application.rateLimitEnforced':
    'Atlassian Intelligence (AI) に対するリクエストが多すぎます。しばらくしてからもう一度お試しください。また、<link>AI の過度の使用</link>についてもご確認ください。',
  'fabric.editor.ai.experience-application.tokenLimitExceeded':
    '応答を取得できませんでした。プロンプトまたは応答が、このリクエストの制限を超えていました。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.experience-application.unhandledErrorMessage':
    '問題が発生しました。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.experience.adfStreamingError': '申し訳ありません。応答を取得できませんでした。',
  'fabric.editor.ai.experience.aifcAdfStreamingError': '申し訳ありません。応答を取得できませんでした。',
  'fabric.editor.ai.experience.aifcApiError': '不明なエラーが発生しました。',
  'fabric.editor.ai.experience.aifcApiErrorRetry': '不明なエラーが発生しました。リロードしてもう一度お試しください。',
  'fabric.editor.ai.experience.aifcAupViolationMessage':
    'コンテンツがアトラシアンの<link>利用規定</link>に準拠していません。',
  'fabric.editor.ai.experience.aifcHipaaContentError':
    'あなたのコンテンツには、HIPAA の制限対象となるコンテンツへのリンクが含まれています。リンクを削除して、もう一度お試しください。',
  'fabric.editor.ai.experience.aifcInputTooShortError':
    'リクエストを完了するには、コンテンツが不足しています。コンテンツを追加してから、もう一度お試しください。',
  'fabric.editor.ai.experience.aifcInternalServerError':
    '申し訳ありません。応答を取得できませんでした。5 分後にもう一度お試しになるか、<link>Rovo のステータスを確認してください</link>。',
  'fabric.editor.ai.experience.aifcRateLimitEnforced':
    '<link>リクエスト数の上限</link>に達しました。5 分ほど待ってから、もう一度お試しください。',
  'fabric.editor.ai.experience.aifcTokenLimitExceeded':
    'コンテンツが多すぎるため処理できません。コンテンツを減らしてから、もう一度お試しください。',
  'fabric.editor.ai.experience.apiError': '応答がありませんでした。もう一度お試しください。',
  'fabric.editor.ai.experience.aupViolationMessage':
    'プロンプトまたはコンテンツがアトラシアンの利用規定に準拠していない可能性があります。必要に応じて、両方を見直し、アトラシアンの<link>利用規定</link>をご参照ください。問題が解決しない場合、別のプロンプトまたはコンテンツを試すことをご検討ください。',
  'fabric.editor.ai.experience.browseMore.agents': 'エージェントを参照する',
  'fabric.editor.ai.experience.discardMessagePrompt': 'プロンプトを破棄してよろしいですか?',
  'fabric.editor.ai.experience.discardMessageResponse': '応答を破棄してよろしいですか?',
  'fabric.editor.ai.experience.discardStreamingInDocumennt': 'リクエストをキャンセルして応答を破棄しますか?',
  'fabric.editor.ai.experience.elevateDisabledGenetateError': '(自由形式の生成は現在 Elevate で無効になっています)。',
  'fabric.editor.ai.experience.engagementBannerLinksText':
    '🚀 Jira と Confluence のコンテンツへのリンク 🔗 をプロンプトに貼り付けられるようになりました。',
  'fabric.editor.ai.experience.footerRightText.agents': 'Rovo を使用',
  'fabric.editor.ai.experience.generatingAiResponse': '生成しています',
  'fabric.editor.ai.experience.hipaaContentError':
    'HIPAA の制限対象となるコンテンツへのリンクが含まれているため、Atlassian Intelligence はリクエストを処理できませんでした。これらのリンクを削除して、もう一度お試しください。',
  'fabric.editor.ai.experience.inputTooShortError':
    '内容が短すぎて要約できません。内容を追加して、もう一度お試しください。',
  'fabric.editor.ai.experience.internalServerError':
    'Atlassian Intelligence (AI) が応答していません。後でもう一度お試しになるか、<link>AI のステータスを確認してください</link>。',
  'fabric.editor.ai.experience.labelRight.atlassianIntelligence': 'Atlassian Intelligence',
  'fabric.editor.ai.experience.labelRight.rovo': 'Rovo',
  'fabric.editor.ai.experience.loadingTitle': '生成しています',
  'fabric.editor.ai.experience.messageTemplateAnalysingQuery': '質問内容を分析しています。',
  'fabric.editor.ai.experience.messageTemplateContentSearch': '情報を検索している間、少々お待ちください。',
  'fabric.editor.ai.experience.messageTemplateNextBestTask': 'Jira を検索している間、少々お待ちください。',
  'fabric.editor.ai.experience.messageTemplatePageHydration': 'ページを検索している間、少々お待ちください。',
  'fabric.editor.ai.experience.noResultsSuggestion': '該当する結果がありません',
  'fabric.editor.ai.experience.noTextualContentError':
    'リクエストを完了するには、コンテンツが不足しています。コンテンツを追加してから、もう一度お試しください。',
  'fabric.editor.ai.experience.responseTooSimilarMessage':
    '現時点で Atlassian Intelligence からの提案はありません。別のプロンプトまたはコンテンツをお気軽にお試しください。',
  'fabric.editor.ai.experience.showMoreButton': 'さらに表示',
  'fabric.editor.ai.experience.suggestionGroupHeading.actions': 'アクション',
  'fabric.editor.ai.experience.suggestionGroupHeading.agents': 'エージェント',
  'fabric.editor.ai.experience.suggestionGroupHeading.atlassianIntelligence': 'Atlassian intelligence',
  'fabric.editor.ai.experience.suggestionGroupHeading.knowledgeSource': 'ナレッジ ソース',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgents': 'Rovo エージェント',
  'fabric.editor.ai.experience.suggestionGroupHeading.rovoAgentsCount': 'Rovo エージェント ({numberOfAgents} 個)',
  'fabric.editor.ai.experience.suggestionGroupHeading.useRovoAgentsCount':
    'Rovo エージェント ({numberOfAgents} 個) を使用',
  'fabric.editor.ai.experience.useGeneralAiKnowledgeLabel': '一般的なナレッジを使用',
  'fabric.editor.ai.experience.useRovoOrganisationKnowledgeLabel': '組織のナレッジを使用',
  'fabric.editor.ai.proactive.error.markdownErrorMessage':
    'プレビューを生成できません。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.proactive.error.unhandledErrorMessage':
    '問題が発生しました。ダイアログを閉じて、もう一度お試しください。',
  'fabric.editor.ai.proactive.preview.insertBelowProactiveRecommendation': '下に挿入',
  'fabric.editor.ai.proactive.preview.replaceProactiveRecommendation': '置換',
  'fabric.editor.ai.screens.preview.convoAIBeta': 'URL を参照するコンテンツ生成リクエストはベータ版です。',
  'fabric.editor.ai.selectionToolbar.define.disabled.tooltip': '用語、頭字語、または略語をハイライトする',
  'fabric.editor.ai.selectionToolbar.define.title': '定義',
  'fabric.editor.ai.telepointer.rovo': 'Rovo',
  'fabric.editor.ai.toolbar.DefineDropdownIconTitle.title': '定義',
  'fabric.editor.ai.toolbar.askAI.title': 'Atlassian Intellgience に質問',
  'fabric.editor.ai.toolbar.askRovo.title': 'Rovo に質問する',
  'fabric.editor.ai.toolbar.askRovo.tooltip.quickCommand': "Rovo に質問 {key}+'",
  'fabric.editor.ai.toolbar.askRovoAiSplitButton.label': 'Rovo AI に質問',
  'fabric.editor.ai.toolbar.changeTone.title': 'トーンを変更する',
  'fabric.editor.ai.toolbar.changeToneOptions.title': 'トーン変更オプション',
  'fabric.editor.ai.toolbar.improveWriting.title': '文章を改善する',
  'fabric.editor.ai.toolbar.improveWriting.tooltip': '選択した文章を改善するよう Atlassian Intelligence に指示します',
  'fabric.editor.ai.toolbar.makeLonger.title': 'もっと長くする',
  'fabric.editor.ai.toolbar.makeShorter.title': 'もっと短くする',
  'fabric.editor.ai.toolbar.moreCasualTone.title': 'よりカジュアルに',
  'fabric.editor.ai.toolbar.moreEmpatheticTone.title': 'より共感を示すように',
  'fabric.editor.ai.toolbar.moreProfessionalTone.title': 'よりプロフェッショナルに',
  'fabric.editor.ai.toolbar.moreRovoOptions.label': 'その他の Rovo オプション',
  'fabric.editor.ai.toolbar.simplifiedAI.title': 'AI',
  'fabric.editor.ai.toolbar.spellingAndGrammar.title': 'スペルと文法を修正する',
  'fabric.editor.ai.toolbar.summarize.title': '要約する',
  'fabric.editor.ai.toolbar.titleText': 'Atlassian Intelligence',
  'fabric.editor.ai.toolbar.translate.title': '翻訳する',
  'fabric.editor.ai.toolbar.translateOptions.label': 'オプションを翻訳',
  'fabric.editor.ai.toolbar.tryAI.title': 'AI を試す',
  'fabric.editor.ai.toolbar.tryAI.tooltip': 'Atlassian Intelligence を開く',
  'fabric.editor.ai.toolbar.tryAI.tooltip.quickCommand': "AI に質問: {key} + '",
  'fabric.editor.alignCenter': '中央揃え',
  'fabric.editor.alignImageCenter': '中央揃え',
  'fabric.editor.alignImageLeft': '左揃え',
  'fabric.editor.alignImageRight': '右揃え',
  'fabric.editor.alignLeft': '左揃え',
  'fabric.editor.alignRight': '右揃え',
  'fabric.editor.alignTableCenter': '中央揃え',
  'fabric.editor.alignTableLeft': '左揃え',
  'fabric.editor.alignment': 'テキストの配置',
  'fabric.editor.altText': '代替テキスト',
  'fabric.editor.alttext.validation': '代替テキスト内の特殊文字を削除してください。',
  'fabric.editor.annotationToolbar': '注釈ツールバー',
  'fabric.editor.backLink': '戻る',
  'fabric.editor.backgroundColor': '背景色',
  'fabric.editor.block.menu.codeblock': 'コード ブロック',
  'fabric.editor.block.menu.copy.block': 'ブロックをコピー',
  'fabric.editor.block.menu.copy.content': 'コンテンツをコピーする',
  'fabric.editor.block.menu.copy.link': 'リンクをコピー',
  'fabric.editor.block.menu.copy.link.to.block': 'ブロックへのリンクをコピー',
  'fabric.editor.block.menu.delete.block': '削除',
  'fabric.editor.block.menu.layout': 'レイアウト',
  'fabric.editor.block.menu.move.down': '下に移動',
  'fabric.editor.block.menu.move.up': '上に移動',
  'fabric.editor.block.menu.paragraph': '段落',
  'fabric.editor.block.menu.turn.into': '次に変換する',
  'fabric.editor.blockCardUnavailable': 'インライン リンクは {node} 内にあるためビューを変更できません',
  'fabric.editor.blockControlDelete': '削除',
  'fabric.editor.blockControlDragHandleMove': 'ドラッグして移動',
  'fabric.editor.blockControlDragHandleMoveOrOpen': 'ドラッグして移動{br}クリックしてメニューを開く',
  'fabric.editor.blockControlDragHandleRearrange': 'ドラッグして並べ替え',
  'fabric.editor.blockControlInsert': '挿入',
  'fabric.editor.blockControlMoveDown': '下に移動',
  'fabric.editor.blockControlMoveLeft': '左に移動',
  'fabric.editor.blockControlMoveRight': '右に移動',
  'fabric.editor.blockControlMoveUp': '上に移動',
  'fabric.editor.blockControlMovedDown': 'コンテンツが下に移動されました',
  'fabric.editor.blockControlMovedUp': 'コンテンツが上に移動されました',
  'fabric.editor.blockDescription': '要約やアクションなど、リンクの詳細を表示します。',
  'fabric.editor.blockTitle': 'カード',
  'fabric.editor.blockquote': '引用',
  'fabric.editor.blockquote.description': '引用文を挿入',
  'fabric.editor.blockquote2': '引用',
  'fabric.editor.bold': '太字',
  'fabric.editor.breakout.resizeCodeBlock': 'コード スニペットのサイズを変更',
  'fabric.editor.breakout.resizeElement': '要素のサイズを変更',
  'fabric.editor.breakout.resizeExpand': '展開コンテンツのサイズを変更',
  'fabric.editor.breakout.resizeLayout': 'レイアウト サイズを変更',
  'fabric.editor.breakoutFullWidthLabel': '全幅',
  'fabric.editor.breakoutWideWidthLabel': '広い',
  'fabric.editor.bug': 'バグ',
  'fabric.editor.bulletedList': '箇条書きリスト',
  'fabric.editor.canNotSortTable': '⚠️ 結合セルを含む表は並べ替えられません。',
  'fabric.editor.cancelButton': 'キャンセル',
  'fabric.editor.captionPlaceholder': 'キャプションを追加',
  'fabric.editor.captionPlaceholderWithDoubleClickPrompt': 'キャプションを追加 - ダブルクリックしてプレビュー',
  'fabric.editor.cardFloatingControls': 'カードのオプション',
  'fabric.editor.cellBackground': 'セルの背景',
  'fabric.editor.cellOptions': 'セルのオプション',
  'fabric.editor.checkUncheckActionItem': 'アクション アイテムを切り替える',
  'fabric.editor.clearAltTextEdit': '代替テキストをクリア',
  'fabric.editor.clearCells': '{0, plural, other {セルをクリア}}',
  'fabric.editor.clearFormatting': 'フォーマットをクリア',
  'fabric.editor.clearLink': 'リンクをクリア',
  'fabric.editor.clearLinkText': 'テキストをクリア',
  'fabric.editor.closeAltTextEdit': '戻る',
  'fabric.editor.closeFindReplaceDialog': '閉じる',
  'fabric.editor.closeHelpDialog': 'ヘルプ ダイアログを閉じる',
  'fabric.editor.code': 'コード',
  'fabric.editor.code.on': '{textFormattingOff}、コード オン',
  'fabric.editor.codeBidiWarningLabel':
    '双方向文字はテキストのレンダリング順序を変更します。このため、悪意のあるコードを隠すために使用される場合があります。',
  'fabric.editor.codeBlockCopyButton.copiedToClipboard': 'コピーしました',
  'fabric.editor.codeBlockCopyButton.copyToClipboard': 'テキストとしてコピー',
  'fabric.editor.codeBlockWrapButton.unwrapCodeBlock': '折り返しをオフ',
  'fabric.editor.codeBlockWrapButton.wrapCodeBlock': '折り返しをオン',
  'fabric.editor.codeblock': 'コード スニペット',
  'fabric.editor.codeblock.description': '構文をハイライトしてコードを表示',
  'fabric.editor.collapseNode': 'コンテンツを折りたたむ',
  'fabric.editor.collapseTable': 'テーブルを折りたたむ',
  'fabric.editor.colorPicker.menuLabel': 'カラー ピッカー メニュー',
  'fabric.editor.columnDragHandle': '列オプション',
  'fabric.editor.columnMovedLeft': '列を左に移動しました。現在、全 {total} 列中 {index} 列目です',
  'fabric.editor.columnMovedRight': '列を右に移動しました。現在、全 {total} 列中 {index} 列目です',
  'fabric.editor.columnSelected': '全 {total} 列中 {index} 列目を選択しました',
  'fabric.editor.columns': 'レイアウト',
  'fabric.editor.columns.advanced.layout.description':
    '{numberOfColumns, plural, other {同等の列を {numberOfColumns} 列挿入します}}',
  'fabric.editor.columns.advanced.layout.single.description': '単一列のレイアウトを挿入します',
  'fabric.editor.columns.description': 'セクションを使用してページを構成',
  'fabric.editor.columnsAreInserted': '{count, plural, other {{count} 件の列が挿入されました}}',
  'fabric.editor.columnsAreRemoved': '{count, plural, other {{count} 件の列が削除されました}}',
  'fabric.editor.configFailedToLoad': '読み込めませんでした',
  'fabric.editor.configPanel.cancel': 'キャンセル',
  'fabric.editor.configPanel.close': '閉じる',
  'fabric.editor.configPanel.customSelect.createOption': '作成',
  'fabric.editor.configPanel.dateRange.custom.from': '開始日',
  'fabric.editor.configPanel.dateRange.custom.to': '終了日',
  'fabric.editor.configPanel.dateRange.grouping.collapse': '折りたたむ',
  'fabric.editor.configPanel.dateRange.grouping.expand': '展開',
  'fabric.editor.configPanel.dateRange.option.custom': 'カスタム',
  'fabric.editor.configPanel.documentation': 'ドキュメント',
  'fabric.editor.configPanel.errorBoundary.note':
    'チームに報告しました。このページは引き続き編集および公開できます。詳細については、エラー コンソールで確認できます。',
  'fabric.editor.configPanel.errorBoundary.title': '問題が発生しました。',
  'fabric.editor.configPanel.fieldTypeError.isMultipleAndRadio':
    '「isMultiple」と「style: radio」を組み合わせることはできません',
  'fabric.editor.configPanel.formType.addField': 'フィールドを追加',
  'fabric.editor.configPanel.formType.removeField': 'フィールドを削除',
  'fabric.editor.configPanel.help': 'お困りですか?',
  'fabric.editor.configPanel.invalid': '無効なフィールド',
  'fabric.editor.configPanel.required': '必須フィールド',
  'fabric.editor.configPanel.submit': '送信',
  'fabric.editor.contextPanel.panelLabel': 'コンテキスト パネル',
  'fabric.editor.copiedToClipboard': 'コピーしました',
  'fabric.editor.copySyncBlock': 'コピー',
  'fabric.editor.copySyncBlockTooltip': '参照をクリップボードにコピー',
  'fabric.editor.copyToClipboard': 'コピー',
  'fabric.editor.cornerControl': 'テーブルをハイライト',
  'fabric.editor.createComment': 'コメント',
  'fabric.editor.createCommentDisabled':
    'テキスト、見出し、絵文字、日付、メンション、リンク、ステータスにのみコメントできます。',
  'fabric.editor.createCommentInvalid': 'テキストと見出しにのみコメントできます',
  'fabric.editor.customPanel': 'カスタム パネル',
  'fabric.editor.customPanel.description': '絵文字と背景色でメモを追加',
  'fabric.editor.datasource.assetsObjects.description':
    '検索とフィルタリングを使用して、Jira Service Management のアセットからオブジェクトを挿入します',
  'fabric.editor.datasource.assetsObjectsGeneralAvailability': 'アセット',
  'fabric.editor.datasource.confluenceSearch': 'Confluence リストを挿入する',
  'fabric.editor.datasource.confluenceSearch.description':
    '強化された検索、フィルタリング、設定を使用して、Confluence から検索結果のリストを挿入します。',
  'fabric.editor.datasource.jiraIssue': 'Jira 課題',
  'fabric.editor.datasource.jiraIssue.description':
    '強化された検索、フィルタリング、設定を使用して、Jira Cloud から Jira 課題を挿入します。',
  'fabric.editor.datasource.jiraIssue.description.issue-term-refresh':
    '強化された検索、フィルタリング、構成を使用して、Jira Cloud から Jira 作業項目を挿入します。',
  'fabric.editor.datasource.jiraIssue.issue-term-refresh': 'Jira 作業項目',
  'fabric.editor.datasourceAppearanceTitle': 'リスト',
  'fabric.editor.datasourceTitle': '検索クエリを編集',
  'fabric.editor.date': '日付',
  'fabric.editor.date.description': 'カレンダーを使用して日付を追加',
  'fabric.editor.datePickerOpenedAlert':
    '日付エディターのポップアップが開きました。Tab キーを押してポップアップにアクセスしてください',
  'fabric.editor.decision': '決定事項',
  'fabric.editor.decision.description': '決定事項をキャプチャして簡単に追跡',
  'fabric.editor.decisionPlaceholder': '決定事項を追加…',
  'fabric.editor.decreaseElementSize': '要素のサイズを縮小',
  'fabric.editor.decreaseSize': '表またはメディアのサイズを小さくする',
  'fabric.editor.defaultAltText': 'ドキュメント',
  'fabric.editor.delete': '削除',
  'fabric.editor.description': '説明',
  'fabric.editor.displayBlock': 'カードを表示',
  'fabric.editor.displayEmbed': '埋め込みを表示',
  'fabric.editor.displayInline': 'インライン表示',
  'fabric.editor.displayLink': 'テキストとして表示',
  'fabric.editor.displayOptionUnavailableInParentNode': '{node} 内ではこの表示オプションを使用できません',
  'fabric.editor.displayText': '表示するテキスト',
  'fabric.editor.distributeColumns': '列の幅を揃える',
  'fabric.editor.dragHandleZone': 'ドラッグ ハンドル ゾーンを有効化する',
  'fabric.editor.dropPlaceholderLabel': 'ドキュメント',
  'fabric.editor.ecombedDescription': 'リンクのインタラクティブなプレビューを表示します。',
  'fabric.editor.edit': '編集',
  'fabric.editor.edit.datasource': '検索クエリを編集',
  'fabric.editor.edit.searchInput': 'リンクを追加',
  'fabric.editor.editAccessTitle': '編集アクセス権が必要です',
  'fabric.editor.editAltText': '代替テキストを編集',
  'fabric.editor.editDatasourceStandalone': '編集',
  'fabric.editor.editDatasourceStandaloneTooltip': '検索クエリを編集',
  'fabric.editor.editDateText': '日付の編集',
  'fabric.editor.editDropdownEditDatasourceTitle': '検索クエリを編集',
  'fabric.editor.editDropdownEditLinkTitle': 'リンクを編集',
  'fabric.editor.editDropdownExpandIconLabel': 'ドロップダウン メニューを展開',
  'fabric.editor.editDropdownTriggerTitle': '編集',
  'fabric.editor.editLink': 'リンクを編集',
  'fabric.editor.editMode.inviteToEditButton.title': '編集に招待',
  'fabric.editor.editSourceLabel': 'ソースを編集',
  'fabric.editor.editSourceTooltip': '同期ブロックのソース ページに移動',
  'fabric.editor.editStatusColor': 'ステータス カラーを編集',
  'fabric.editor.editStatusText': 'ステータスを編集',
  'fabric.editor.editableContentLabel': '編集可能なコンテンツ',
  'fabric.editor.editorHelp': 'エディター ヘルプ',
  'fabric.editor.editors': '編集者',
  'fabric.editor.elementBrowser.help': 'ヘルプ',
  'fabric.editor.elementInsertSidePanel.title': '挿入',
  'fabric.editor.elementbrowser.categorylist.category-admin': '管理',
  'fabric.editor.elementbrowser.categorylist.category-ai': 'Atlassian Intelligence',
  'fabric.editor.elementbrowser.categorylist.category-all': 'すべて',
  'fabric.editor.elementbrowser.categorylist.category-communication': 'コミュニケーション',
  'fabric.editor.elementbrowser.categorylist.category-confluence-content': 'Confluence コンテンツ',
  'fabric.editor.elementbrowser.categorylist.category-development': '開発',
  'fabric.editor.elementbrowser.categorylist.category-external-content': '外部コンテンツ',
  'fabric.editor.elementbrowser.categorylist.category-formatting': 'フォーマット',
  'fabric.editor.elementbrowser.categorylist.category-media': 'メディア',
  'fabric.editor.elementbrowser.categorylist.category-navigation': 'ナビゲーション',
  'fabric.editor.elementbrowser.categorylist.category-reporting': 'レポート',
  'fabric.editor.elementbrowser.categorylist.category-visuals': 'ビジュアルと画像',
  'fabric.editor.elementbrowser.featured.whiteboard.description':
    'ホワイトボードを使用してページにビジュアルを追加します',
  'fabric.editor.elementbrowser.search.empty-state.heading': '検索条件に一致するデータがありませんでした',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading':
    '別の用語で検索するか、アトラシアン製品の新しいアプリを探してください。',
  'fabric.editor.elementbrowser.search.empty-state.sub-heading.link': 'Atlassian Marketplace を見る',
  'fabric.editor.elementbrowser.searchbar.assistive.text.default':
    '{count, plural, =0 {検索に一致するものがありません。} other {既定で {count} 件の候補が利用可能です。}}',
  'fabric.editor.elementbrowser.searchbar.assistive.text.result':
    '{count, plural, =0 {検索に一致するものがありません。} other {入力したテキストでは {count} 件の候補が利用可能です。}}',
  'fabric.editor.elementbrowser.searchbar.elementAfterInput': 'Enter',
  'fabric.editor.elementbrowser.searchbar.placeholder': '検索',
  'fabric.editor.elementbrowser.sidebar.heading': '参照',
  'fabric.editor.embedTitle': '埋め込み',
  'fabric.editor.embedToBlockCardWarning': '小さい画面ではカードとして表示されます',
  'fabric.editor.emoji': '絵文字',
  'fabric.editor.emoji.description': '絵文字を使用してアイデア 🎉 や気持ち 😄 を表現',
  'fabric.editor.emptyLink': 'リンクを入力してください。',
  'fabric.editor.emptySearchResults': '結果が見つかりませんでした。',
  'fabric.editor.emptySearchResultsSuggestion': '[{buttonName}] を選択して挿入するアイテムを参照してください。',
  'fabric.editor.epic': 'エピック',
  'fabric.editor.error': 'エラー',
  'fabric.editor.errorPanel': 'エラー パネル',
  'fabric.editor.errorPanel.description': '色付きのパネルでエラーをコールアウト',
  'fabric.editor.expand': '展開',
  'fabric.editor.expand.description': '展開を挿入',
  'fabric.editor.expandAriaLabel': 'この展開にタイトルを付ける',
  'fabric.editor.expandDefaultTitle': 'こちらをクリックして展開…',
  'fabric.editor.expandNode': 'コンテンツを展開',
  'fabric.editor.expandPlaceholder': 'この展開にタイトルを付ける…',
  'fabric.editor.extension.confirmDeleteLinkedModalMessage':
    '{nodeName} を削除すると、接続されているすべてが破棄されます。',
  'fabric.editor.extension.confirmDeleteLinkedModalMessagePrefix': '削除: ',
  'fabric.editor.extension.confirmDeleteLinkedModalOKButton': '削除',
  'fabric.editor.extension.deleteElementTitle': '要素の削除',
  'fabric.editor.extension.sourceNoTitledName': 'この要素',
  'fabric.editor.extensions.config-panel.save-indicator': 'すべての変更は常に自動保存されます',
  'fabric.editor.externalExtensionsHeading': 'アプリ',
  'fabric.editor.externalMediaFile': '外部メディア ファイル',
  'fabric.editor.failed_to_upload': 'アップロードに失敗しました',
  'fabric.editor.feedbackDialog': 'フィードバックを送信',
  'fabric.editor.feedbackDialog.description': 'クラウド エディターをご利用になった感想をお聞かせください',
  'fabric.editor.find': '検索',
  'fabric.editor.findNext': '次を検索',
  'fabric.editor.findPrevious': '前を検索',
  'fabric.editor.findReplaceToolbarButton': '検索と置換',
  'fabric.editor.fiveColumns': '5 列レイアウト',
  'fabric.editor.floatingToolbar.confirmModalCancel': 'キャンセル',
  'fabric.editor.floatingToolbar.confirmModalCheckboxLabel': '接続されている要素も削除',
  'fabric.editor.floatingToolbar.confirmModalConnectedUnit':
    '{amount, plural, =0 {{name}} other {{name} (+ {amount,number} 件の接続されている要素)}}',
  'fabric.editor.floatingToolbar.confirmModalHeading': '実行しますか?',
  'fabric.editor.floatingToolbar.confirmModalOK': 'OK',
  'fabric.editor.floatingToolbar.floatingToolbarAnnouncer': 'フローティング ツールバーのコントロールが開いています。',
  'fabric.editor.floatingToolbar.floatingToolbarAriaLabel': 'フローティング ツールバー',
  'fabric.editor.floatingToolbar.floatingToolbarRadioGroupAriaLabel': 'レイアウト オプション',
  'fabric.editor.floatingToolbar.scrollLeft': '左にスクロール',
  'fabric.editor.floatingToolbar.scrollRight': '右にスクロール',
  'fabric.editor.focusTableResizeHandle': 'フォーカス表のサイズ変更ハンドル',
  'fabric.editor.fourColumns': '4 列レイアウト',
  'fabric.editor.headerColumn': 'ヘッダーの列',
  'fabric.editor.headerRow': 'ヘッダーの行',
  'fabric.editor.heading1': '見出し 1',
  'fabric.editor.heading1Description': '最上位レベルの見出しに使用',
  'fabric.editor.heading2': '見出し 2',
  'fabric.editor.heading2Description': 'キー セクションに使用',
  'fabric.editor.heading3': '見出し 3',
  'fabric.editor.heading3Description': 'サブセクションおよびグループ見出しに使用',
  'fabric.editor.heading4': '見出し 4',
  'fabric.editor.heading4Description': '階層見出しに使用',
  'fabric.editor.heading5': '見出し 5',
  'fabric.editor.heading5Description': 'リスト アイテムのグループ化に使用',
  'fabric.editor.heading6': '見出し 6',
  'fabric.editor.heading6Description': '下位レベルの見出しに使用',
  'fabric.editor.headingLink.ascOrderLabel': '列のソート: Z から A',
  'fabric.editor.headingLink.descOrderLabel': 'ソートをクリア',
  'fabric.editor.headingLink.hyperlinkIconBlogLabel': 'ブログ',
  'fabric.editor.headingLink.hyperlinkIconBugLabel': 'バグ',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel': '課題',
  'fabric.editor.headingLink.hyperlinkIconIssueLabel.issue-term-refresh': '作業項目',
  'fabric.editor.headingLink.hyperlinkIconPageLabel': 'ページ',
  'fabric.editor.headingLink.hyperlinkIconStoryLabel': 'ストーリー',
  'fabric.editor.headingLink.hyperlinkIconTaskLabel': 'タスク',
  'fabric.editor.headingLink.invalidLabel': '⚠️ 統合したセルで表を並べ替えることはできません',
  'fabric.editor.headingLink.noOrderLabel': '列のソート: A から Z',
  'fabric.editor.help': 'ヘルプ',
  'fabric.editor.help.description': 'キーボード ショートカットと Markdown のオプションをすべて表示',
  'fabric.editor.helpDialogTips': '{keyMap} を押すと、このダイアログをいつでもすぐに開けます',
  'fabric.editor.highlight': '強調色',
  'fabric.editor.highlight.removeColor': '色を削除',
  'fabric.editor.highlightColor': '強調色パレットを切り替える',
  'fabric.editor.highlightFloatingToolbar': 'ハイライト',
  'fabric.editor.horizontalRule': '分割線',
  'fabric.editor.horizontalRule.description': '横線を使用してコンテンツを分割',
  'fabric.editor.hyperlink.linkVisibleLabel': 'リンクを貼り付けるか検索',
  'fabric.editor.hyperlink.searchLinkAriaDescription': 'フィールドに入力すると、以下に候補が表示されます',
  'fabric.editor.hyperlink.searchLinkResults':
    '{count, plural, =0 {検索結果がありませんでした} other {{count,number} 件の検索結果が見つかりました}}',
  'fabric.editor.hyperlink.textVisibleLabel': '表示テキスト (オプション)',
  'fabric.editor.hyperlinkToolbarPlaceholder': 'リンクを貼り付けるか検索',
  'fabric.editor.image': '画像',
  'fabric.editor.image.fullWidthLabel': '全幅',
  'fabric.editor.imageBorderBold': '太',
  'fabric.editor.imageBorderColor': '色',
  'fabric.editor.imageBorderColor.dropdownAriaLabel': 'イメージ枠線オプションの [色] ドロップダウン',
  'fabric.editor.imageBorderMedium': '中',
  'fabric.editor.imageBorderOptions': '枠のオプション',
  'fabric.editor.imageBorderSize': 'サイズ',
  'fabric.editor.imageBorderSize.dropdownAriaLabel': 'イメージ枠線オプションの [サイズ] ドロップダウン',
  'fabric.editor.imageBorderSubtle': '細',
  'fabric.editor.improvement': '改善',
  'fabric.editor.increaseElementSize': '要素のサイズを拡大',
  'fabric.editor.increaseSize': '表またはメディアのサイズを大きくする',
  'fabric.editor.indent': 'インデント',
  'fabric.editor.info': '情報',
  'fabric.editor.infoPanel': '情報パネル',
  'fabric.editor.infoPanel.description': '色付きのパネルで情報を強調',
  'fabric.editor.inlineConfigureLink': 'リンクを設定',
  'fabric.editor.inlineDescription': 'リンクをインライン テキストとして表示します。',
  'fabric.editor.inlineGoToLink': 'リンクへ移動',
  'fabric.editor.inlineOverlay': '構成',
  'fabric.editor.inlineTitle': 'インライン',
  'fabric.editor.inputQueryAssistiveTxt':
    'オートコンプリートの結果を利用できる際は、上下の矢印キーによって確認して Enter キーを押して選択します。タッチ デバイスのユーザーは、タッチまたはスワイプして検索してください。',
  'fabric.editor.insertColumn': '列を右に挿入',
  'fabric.editor.insertColumnDrag': '列を挿入',
  'fabric.editor.insertMenu': '要素を挿入',
  'fabric.editor.insertRightRail.close': '閉じる',
  'fabric.editor.insertRightRail.title': '挿入',
  'fabric.editor.insertRow': '行を下に挿入',
  'fabric.editor.insertRowDrag': '行を挿入',
  'fabric.editor.insertTableColumn': '表の列を挿入する',
  'fabric.editor.insertTableRow': '表の行を挿入する',
  'fabric.editor.invalidDateError': '有効な日付を入力してください',
  'fabric.editor.invalidLink': '有効なリンクを入力してください。',
  'fabric.editor.inviteItem.title':
    '{userRole, select, admin {チームメイトを {productName} に招待} trusted {チームメイトを {productName} に招待} other {チームメイトを {productName} に追加}}',
  'fabric.editor.italic': '斜体',
  'fabric.editor.keyboardShortcuts': 'キーボード ショートカット',
  'fabric.editor.layout.columnOption': '{count, plural, other {{count} 列}}',
  'fabric.editor.layout.controls.placeholder': '「/」と入力して挿入',
  'fabric.editor.layout.placeholder': 'コンテンツを追加',
  'fabric.editor.layout.resizeLayout': 'レイアウトのサイズ変更',
  'fabric.editor.layoutFixedWidth': '標準の幅に戻す',
  'fabric.editor.layoutFullWidth': '全幅で表示',
  'fabric.editor.layoutStateFixedWidth': '中央揃え',
  'fabric.editor.layoutStateFullWidth': '全幅',
  'fabric.editor.layoutStateWide': '広い',
  'fabric.editor.layoutWide': 'ワイド表示',
  'fabric.editor.leftSidebar': '左サイド バー レイアウト',
  'fabric.editor.link': 'リンク',
  'fabric.editor.link.description': 'リンクを挿入',
  'fabric.editor.linkAddress': 'リンクのアドレス',
  'fabric.editor.linkPlaceholder': 'リンクを貼り付け',
  'fabric.editor.lists': 'リスト',
  'fabric.editor.listsFormat': 'リスト書式設定',
  'fabric.editor.lockColumns': '固定列幅',
  'fabric.editor.longEmptyNodePlaceholderText': '要素を挿入するには「/」と入力します',
  'fabric.editor.markdown': 'マークダウン',
  'fabric.editor.matchCase': '大文字/小文字を区別',
  'fabric.editor.media.DefaultMediaWidthDecreased':
    '{newMediaWidth, plural, other {メディア幅が {newMediaWidth,number} ピクセルに縮小しました。}}',
  'fabric.editor.media.DefaultMediaWidthIncreased':
    '{newMediaWidth, plural, other {メディア幅が {newMediaWidth,number} ピクセルに拡大しました。}}',
  'fabric.editor.media.MediaWidthIsMin': 'メディアが最小サイズに縮小されました',
  'fabric.editor.media.insert.cancel': 'キャンセル',
  'fabric.editor.media.insert.fileTabTitle': 'ファイル',
  'fabric.editor.media.insert.fromUrlErrorMessage':
    '残念ながら、この画像リンクは追加できません。画像をダウンロードして、ページにドラッグ & ドロップしてください。',
  'fabric.editor.media.insert.fromUrlWarning':
    'ソースの制限によってはこの画像がユーザーに表示されない可能性があります。代わりにファイルをアップロードすることをご検討ください。',
  'fabric.editor.media.insert.insert': '挿入',
  'fabric.editor.media.insert.invalidUrlErrorMessage': '無効なリンク',
  'fabric.editor.media.insert.linkTabTitle': 'リンク',
  'fabric.editor.media.insert.loadPreview': 'プレビューを読み込む',
  'fabric.editor.media.insert.localFileErrorMessage': 'このファイルをアップロードできませんでした。',
  'fabric.editor.media.insert.localFileNetworkErrorMessage':
    'ファイルのアップロード エラーが発生しました。ファイル パスまたはネットワークを確認してください。',
  'fabric.editor.media.insert.mediaAlt': 'アップロードした画像または動画ファイルのプレビュー',
  'fabric.editor.media.insert.mediaPickerPopupAriaLabel': 'メディア ピッカー',
  'fabric.editor.media.insert.pasteLinkToUpload': 'リンクを貼り付けてアップロード',
  'fabric.editor.media.insert.upload': 'アップロード',
  'fabric.editor.media.pixelEntry.MediaWidthIsMax': 'メディアが最大サイズに拡大されました',
  'fabric.editor.media.pixelEntry.ResizeOption': 'サイズ変更',
  'fabric.editor.media.pixelEntry.closePixelEntry': '閉じる',
  'fabric.editor.media.pixelEntry.inputHeightAriaLabel': '高さの入力',
  'fabric.editor.media.pixelEntry.inputHeightTooltip': '高さ',
  'fabric.editor.media.pixelEntry.inputWidthAriaLabel': '最大幅 {maxWidth} px',
  'fabric.editor.media.pixelEntry.inputWidthLabel': '幅',
  'fabric.editor.media.pixelEntry.inputWidthTooltip': '最大幅 {maxWidth} px',
  'fabric.editor.media.pixelEntry.migrationButtonText': 'ピクセルに変換',
  'fabric.editor.media.pixelEntry.migrationButtonTooltip': '比率から固定ピクセル サイズに移行',
  'fabric.editor.media.pixelEntry.submitButtonText': '送信',
  'fabric.editor.media.pixelEntry.validationFailedMessage': '幅を検証できませんでした',
  'fabric.editor.mediaAddLink': 'リンクを追加',
  'fabric.editor.mediaFiles': '画像、動画、またはファイル',
  'fabric.editor.mediaFiles.description': '画像やファイルをページに追加',
  'fabric.editor.mediaGroupDeleteLabel': '削除',
  'fabric.editor.media_change_mediainline_caption_warn': 'インライン (キャプションは削除されます)',
  'fabric.editor.media_change_mediainline_default': 'インライン',
  'fabric.editor.media_change_mediasingle': '元のサイズ',
  'fabric.editor.mention': 'メンション',
  'fabric.editor.mention.description': 'ユーザーをメンションして通知を送信します',
  'fabric.editor.mentionNode.label': 'タグ付けされたユーザー',
  'fabric.editor.mentionsAddLabel': '追加アイコン',
  'fabric.editor.mentionsIconLabel': 'メンション',
  'fabric.editor.mergeCells': 'セルを結合',
  'fabric.editor.moreFormatting': 'その他のフォーマット',
  'fabric.editor.moveColumnLeft': '{0, plural, other {左に列を移動}}',
  'fabric.editor.moveColumnRight': '{0, plural, other {右に列を移動}}',
  'fabric.editor.moveDownDown': '{0, plural, other {下に行を移動}}',
  'fabric.editor.moveRowUp': '{0, plural, other {上に行を移動}}',
  'fabric.editor.navigate.toolbar.askAI': 'AI に質問',
  'fabric.editor.navigate.toolbar.editor': 'エディター ツールバーに移動',
  'fabric.editor.navigate.toolbar.floating': 'フローティング ツールバーに移動',
  'fabric.editor.noPermissionToAddComment':
    '{contentType, select, blogpost {このブログ投稿にコメントを追加する権限がありません} page {このページにコメントを追加する権限がありません} other {このページにコメントを追加する権限がありません}}',
  'fabric.editor.noResultsFound': '該当する結果がありません',
  'fabric.editor.noSearchResults': '検索結果が見つかりませんでした。',
  'fabric.editor.normal': 'ノーマル テキスト',
  'fabric.editor.note': 'メモ',
  'fabric.editor.notePanel': 'メモ パネル',
  'fabric.editor.notePanel.description': '色付きのメモ パネルを追加',
  'fabric.editor.numberedColumn': '番号付き列',
  'fabric.editor.off': '{formattingType}オフ',
  'fabric.editor.on': '{formattingType}オン',
  'fabric.editor.openButtonTitle': 'オープン',
  'fabric.editor.openCellOptions': 'セルのオプションを開く',
  'fabric.editor.openLink': 'リンクを新しいタブで開く',
  'fabric.editor.openPreviewPanel': 'プレビュー パネルを開く',
  'fabric.editor.orderedList': '番号付きリスト',
  'fabric.editor.orderedList.description': '順序指定済みリストを作成',
  'fabric.editor.other': 'その他…',
  'fabric.editor.outdent': 'インデント解除',
  'fabric.editor.overflowMenuViewMore': 'さらに表示',
  'fabric.editor.pageActionsLabel': 'ページ操作',
  'fabric.editor.panel': 'パネル',
  'fabric.editor.panel.backgroundColor': '背景色',
  'fabric.editor.panel.custom': 'カスタム',
  'fabric.editor.panel.emoji': '絵文字を追加',
  'fabric.editor.panel.panelsGroup': 'パネル タイプ',
  'fabric.editor.panelButtonTitle': 'パネル',
  'fabric.editor.pasteOptions': '貼り付けオプション',
  'fabric.editor.pastePlainText': 'プレーン テキストを貼り付け',
  'fabric.editor.placeholderAltText': '代替テキストでこの画像を説明',
  'fabric.editor.placeholderText': 'プレースホルダー テキスト',
  'fabric.editor.placeholderText.description': 'ページにテキスト プレースホルダーを挿入',
  'fabric.editor.placeholderTextPlaceholder': 'プレースホルダー テキストを追加',
  'fabric.editor.plainText': 'プレーン テキストを使用する',
  'fabric.editor.preferencesLink': 'リンク設定',
  'fabric.editor.previewButtonTitle': 'プレビュー',
  'fabric.editor.quickInsert': 'クイック挿入',
  'fabric.editor.recordLoomShortTitle': '録画',
  'fabric.editor.recordVideo': 'Loom 動画を録画する',
  'fabric.editor.recordVideo.description': '画面と意見を記録して共有します',
  'fabric.editor.redo': 'やり直し',
  'fabric.editor.remove': '削除',
  'fabric.editor.removeColumns': '{0, plural, other {列を削除}}',
  'fabric.editor.removeEmoji': '絵文字を削除',
  'fabric.editor.removeImageBorder': '枠を削除',
  'fabric.editor.removeRows': '{0, plural, other {行を削除}}',
  'fabric.editor.replace': '置換',
  'fabric.editor.replaceAll': 'すべて置換',
  'fabric.editor.replaceSuccess':
    '{numberOfMatches, plural, other {一致した {numberOfMatches,number} 件が置換されました}}',
  'fabric.editor.replaceWith': '次で置換',
  'fabric.editor.requestToEdit': '編集をリクエスト',
  'fabric.editor.requestToEditDescription': 'アクセス権をリクエストすると、ページの所有者に通知が届きます。',
  'fabric.editor.requestToEditDismiss': '閉じる',
  'fabric.editor.resizeHandle': 'サイズ変更ハンドル',
  'fabric.editor.resultsCount': '{totalResultsCount} 件中 {selectedMatchPosition} 件',
  'fabric.editor.richText': 'リッチ テキストを使用する',
  'fabric.editor.rightSidebar': '右サイド バー レイアウト',
  'fabric.editor.rowControl': '行をハイライト',
  'fabric.editor.rowDragHandle': '行オプション',
  'fabric.editor.rowMovedDown': '行を下に移動しました。現在、全 {total} 行中 {index} 行目です',
  'fabric.editor.rowMovedUp': '行を上に移動しました。現在、全 {total} 行中 {index} 行目です',
  'fabric.editor.rowSelected': '全 {total} 行中 {index} 行目を選択しました',
  'fabric.editor.rowsAreInserted': '{count, plural, other {{count} 件の行が挿入されました}}',
  'fabric.editor.rowsAreRemoved': '{count, plural, other {{count} 件の行が削除されました}}',
  'fabric.editor.saveButton': '保存',
  'fabric.editor.searchResults':
    '{itemsLength, plural, other {{itemsLength,number} 件の検索結果があります。上下の矢印キーで目的のオプションに移動します。Enter キーでオプションを選択します。}}',
  'fabric.editor.selectColumnResize': '列のサイズ変更を選択する',
  'fabric.editor.selectLanguage': '言語を選択',
  'fabric.editor.selectTableColumn': '表の列を選択します',
  'fabric.editor.selectTableRow': '表の行を選択します',
  'fabric.editor.selectionExtensionDropdownButtonLabel': 'アプリを選択',
  'fabric.editor.selectionToolbarOverflowMenuTooltip': 'その他のオプション',
  'fabric.editor.settingsLinks': 'リンク設定に移動',
  'fabric.editor.shortEmptyNodePlaceholderText': '「/」と入力して挿入',
  'fabric.editor.shortcut': 'テキスト ショートカット',
  'fabric.editor.single': '1 列レイアウト',
  'fabric.editor.singleColumns': '1 列レイアウト',
  'fabric.editor.sortColumnASC': '列の並べ替え: 昇順',
  'fabric.editor.sortColumnDESC': '列の並べ替え: 降順',
  'fabric.editor.sortColumnDecreasing': '降順で並べ替え',
  'fabric.editor.sortColumnIncreasing': '昇順で並べ替え',
  'fabric.editor.splitCell': 'セルを分割',
  'fabric.editor.status': 'ステータス',
  'fabric.editor.status.description': 'カスタム ステータス ラベルを追加',
  'fabric.editor.statusEditorLabel': 'ステータス エディター',
  'fabric.editor.statusPickerOpenedAlert':
    'ステータス エディターのポップアップが開きました。Tab キーを押してポップアップにアクセスしてください',
  'fabric.editor.statusPlaceholder': 'ステータスを設定',
  'fabric.editor.story': 'ストーリー',
  'fabric.editor.strike': '取り消し線',
  'fabric.editor.subTask': 'サブタスク',
  'fabric.editor.subscript': '下付き文字',
  'fabric.editor.subscript.off.superscript.on': '下付き文字オフ、上付き文字オン',
  'fabric.editor.success': '成功',
  'fabric.editor.successPanel': '成功パネル',
  'fabric.editor.successPanel.description': '色付きのパネルでヒントを追加',
  'fabric.editor.superscript': '上付き文字',
  'fabric.editor.superscript.off.subscript.on': '上付き文字オフ、下付き文字オン',
  'fabric.editor.supportAltText':
    '代替テキストは視覚障がいがあるためスクリーン リーダーを使用している人に便利な機能です。',
  'fabric.editor.syncBlockGroup': '同期ブロックのタイプ',
  'fabric.editor.syncedBlock': '同期されたブロック',
  'fabric.editor.syncedBlock.description': 'Atlassian アプリ全体でコンテンツを自動更新します',
  'fabric.editor.table': '表',
  'fabric.editor.table.description': '表を挿入',
  'fabric.editor.tableAlignmentOptions': '配置オプション',
  'fabric.editor.tableFullWidthLabel': '全幅',
  'fabric.editor.tableHeader.sorting.asc': '昇順でソートされています',
  'fabric.editor.tableHeader.sorting.default': '列をソート',
  'fabric.editor.tableHeader.sorting.desc': '降順でソートされています',
  'fabric.editor.tableHeader.sorting.invalid': '結合セルを含む表は並べ替えられません',
  'fabric.editor.tableHeader.sorting.no': '並べ替えは列に適用されていません',
  'fabric.editor.tableOptions': '表のオプション',
  'fabric.editor.tableResizeDecreaseScreenReaderInformation':
    '{newWidth, plural, other {テーブル幅が {newWidth,number} ピクセルに縮小しました。}}',
  'fabric.editor.tableResizeIncreaseScreenReaderInformation':
    '{newWidth, plural, other {表の幅が {newWidth,number} ピクセルに拡大しました。}}',
  'fabric.editor.tableScrollRegion': '表のスクロール領域',
  'fabric.editor.tableSelector': '表のサイズ',
  'fabric.editor.tableSelector.description': 'カスタム サイズを指定するポップアップを使用して表を追加します',
  'fabric.editor.tableSizeSelectorButton': '{numberOfColumns} x {numberOfRows}',
  'fabric.editor.tableSizeSelectorPopup': '表サイズ セレクター',
  'fabric.editor.tables.adjustColumn': '列を調整する',
  'fabric.editor.tables.columnResizeLast': 'この列は左側方向のみサイズを変更できます。',
  'fabric.editor.tables.columnResizeOverflow':
    'この列のサイズを変更できるのは、表にスクロール バーがあるときのみです。',
  'fabric.editor.tables.columnWidth': '{width, plural, other {列の幅が {width} ピクセルに変更されました}}',
  'fabric.editor.tables.confirmDeleteLinkedModalMessage':
    '{nodeName} を削除すると、接続されているすべてが破棄されます。',
  'fabric.editor.tables.confirmDeleteLinkedModalOKButton': '削除',
  'fabric.editor.tables.resizeStop': 'サイズ変更を中止しました',
  'fabric.editor.tables.resizeTable': 'テーブルのサイズを変更する',
  'fabric.editor.tables.startedColumnResize': '列のサイズ変更を開始しました',
  'fabric.editor.task': 'タスク',
  'fabric.editor.taskDecision.markTaskAsCompleted': 'タスクを完了としてマーク',
  'fabric.editor.taskDecision.markTaskAsNotCompleted': 'タスクを未完了としてマーク',
  'fabric.editor.taskList': 'タスク リスト',
  'fabric.editor.taskPlaceholder': 'アクションを入力し、「@」を使用して担当者を割り当てます。',
  'fabric.editor.text.formatting.off': 'テキスト書式設定オフ',
  'fabric.editor.textColor': '「{selectedColorName}」テキスト カラー',
  'fabric.editor.textColorHighlightTooltip': 'テキストとハイライトの色',
  'fabric.editor.textColorTooltip': 'テキストの色',
  'fabric.editor.textFormat': 'テキストを書式設定',
  'fabric.editor.textFormatting': 'テキスト書式設定',
  'fabric.editor.textStyles': '「{blockTypeName}」テキスト スタイル',
  'fabric.editor.textStylesTooltip': 'テキスト スタイル',
  'fabric.editor.threeColumns': '3 列レイアウト',
  'fabric.editor.threeColumnsWithLeftSidebars': '左サイド バー付き 3 列レイアウト',
  'fabric.editor.threeColumnsWithRightSidebars': '右サイド バー付き 3 列レイアウト',
  'fabric.editor.threeColumnsWithSidebars': 'サイド バー付き 3 列レイアウト',
  'fabric.editor.time.ago': '前',
  'fabric.editor.time.updated': '最終更新',
  'fabric.editor.time.viewed': '最終閲覧',
  'fabric.editor.toolbarAppears': 'ツールバーの表示',
  'fabric.editor.toolbarLabel': 'エディター',
  'fabric.editor.toolbarMediaTitle': '画像、動画、またはファイルを追加',
  'fabric.editor.toolbarPositionFixedAtTop': '最上部に固定',
  'fabric.editor.toolbarPositionInline': 'テキスト行内',
  'fabric.editor.toolbarPositionPinedAtTop': 'ツール バーのピン留めを解除',
  'fabric.editor.toolbarPositionUnpined': '上部のツール バーをピン留め',
  'fabric.editor.toolbarPositionUnpinnedConcise': 'ツール バーを上部に固定',
  'fabric.editor.tooltip.blockPanel': 'パネル',
  'fabric.editor.tooltip.bulletList': 'リスト',
  'fabric.editor.tooltip.decisionList': '決定事項リスト',
  'fabric.editor.tooltip.defaultBlockNode': 'ブロック ノード',
  'fabric.editor.tooltip.nestedExpand': '入れ子の展開ノード',
  'fabric.editor.tooltip.taskList': 'アクション アイテム',
  'fabric.editor.turnInto': '次に変換する',
  'fabric.editor.twoColumns': '2 列レイアウト',
  'fabric.editor.typeAhead.popupLabel': '先行入力の結果',
  'fabric.editor.typeAhead.quickInsertInputLabel':
    'ショートカット オプションを検索または絞り込むには、入力を開始してください。',
  'fabric.editor.typeAhead.quickInsertInputPlaceholderLabel': '検索',
  'fabric.editor.typeAhead.quickInsertPopupLabel': '挿入と書式設定のショートカット',
  'fabric.editor.typeAheadErrorFallbackDescription': '結果はありません。 もう一度お試しください。',
  'fabric.editor.typeAheadErrorFallbackHeading': '問題が発生しました。',
  'fabric.editor.typeahead.emojiInputLabel': '絵文字オプションを検索または絞り込むには、入力を開始してください。',
  'fabric.editor.typeahead.emojiListItemLabel': '絵文字 {name} テキスト ショートカット {shortcut}',
  'fabric.editor.typeahead.emojiPopupLabel': '絵文字ショートカット',
  'fabric.editor.typeahead.mentionInputLabel': 'タグ付けするユーザーを検索するには、入力を開始してください。',
  'fabric.editor.typeahead.mentionPopupLabel': 'タグ付けできるユーザー',
  'fabric.editor.typeahead.metionListItemLabel': 'ユーザー {name} @{shortName}',
  'fabric.editor.unableToLoadContent': 'このコンテンツを読み込めませんでした',
  'fabric.editor.unableToOpenLink': 'このリンクを開けません',
  'fabric.editor.underline': '下線',
  'fabric.editor.undo': '元に戻す',
  'fabric.editor.unknown.label': '不明',
  'fabric.editor.unlink': 'リンクを解除',
  'fabric.editor.unorderedList': '箇条書きリスト',
  'fabric.editor.unorderedList.description': '順序指定なしのリストを作成',
  'fabric.editor.unsupportedBlockContent': 'このエディターはこのコンテンツの表示をサポートしていません',
  'fabric.editor.unsupportedContentTooltip':
    'このエディターではコンテンツが利用できないため、編集および保存の際にはコンテンツが保持されます',
  'fabric.editor.unsupportedInlineContent': 'サポートされていないコンテンツ',
  'fabric.editor.upDown': '次の入力フィールドで上矢印キーまたは下矢印キーを使用すると、下の日付が更新されます',
  'fabric.editor.url': 'URL を表示',
  'fabric.editor.urlDescription': 'リンクを URL として表示します。',
  'fabric.editor.urlTitle': 'URL',
  'fabric.editor.useMarkdown': 'マークダウンを使用する',
  'fabric.editor.viewAndAddCommentsOnMedia': 'コメントを表示および追加',
  'fabric.editor.viewCommentOnMedia': 'コメントを見る',
  'fabric.editor.viewMore': 'さらに表示',
  'fabric.editor.viewMoreAriaLabel': 'すべての要素を表示',
  'fabric.editor.visit': 'リンクを新しいウィンドウで開く',
  'fabric.editor.warning': '警告',
  'fabric.editor.warningPanel': '警告パネル',
  'fabric.editor.warningPanel.description': '色付きのパネルで注意を促すメモを追加',
  'fabric.editor.wrapLeft': '左揃え',
  'fabric.editor.wrapRight': '右揃え',
  'fabric.emoji.label': '絵文字',
  'fabric.theme.blue': '青',
  'fabric.theme.bold-blue': '濃いめの青',
  'fabric.theme.bold-gray': '濃いめの灰色',
  'fabric.theme.bold-green': '濃いめの緑',
  'fabric.theme.bold-magenta': '濃いめのマゼンタ',
  'fabric.theme.bold-orange': '濃いめのオレンジ',
  'fabric.theme.bold-purple': '濃いめの紫',
  'fabric.theme.bold-red': '濃いめの赤',
  'fabric.theme.bold-teal': '濃いめの青緑',
  'fabric.theme.bold-yellow': '濃いめの黄色',
  'fabric.theme.bolder-blue': '濃い青',
  'fabric.theme.bolder-gray': '濃い灰色',
  'fabric.theme.bolder-green': '濃い緑',
  'fabric.theme.bolder-magenta': '濃いマゼンタ',
  'fabric.theme.bolder-orange': '濃いオレンジ',
  'fabric.theme.bolder-purple': '濃い紫',
  'fabric.theme.bolder-red': '濃い赤',
  'fabric.theme.bolder-teal': '濃いティール',
  'fabric.theme.bolder-yellow': '濃い黄色',
  'fabric.theme.dark-blue': '濃い青',
  'fabric.theme.dark-gray': '濃い灰色',
  'fabric.theme.dark-green': '濃い緑',
  'fabric.theme.dark-purple': '濃い紫',
  'fabric.theme.dark-red': '濃い赤',
  'fabric.theme.dark-teal': '濃い青緑',
  'fabric.theme.dark-yellow': '濃い黄色',
  'fabric.theme.default': '既定',
  'fabric.theme.gray': '灰色',
  'fabric.theme.green': '緑',
  'fabric.theme.light-blue': '薄い青',
  'fabric.theme.light-gray': '薄い灰色',
  'fabric.theme.light-green': '薄い緑',
  'fabric.theme.light-purple': '薄い紫',
  'fabric.theme.light-red': '薄い赤',
  'fabric.theme.light-teal': '薄い青緑',
  'fabric.theme.light-yellow': '薄い黄色',
  'fabric.theme.lime': 'ライム色',
  'fabric.theme.magenta': 'マゼンタ',
  'fabric.theme.no-color': '強調なし',
  'fabric.theme.orange': 'オレンジ',
  'fabric.theme.purple': '紫',
  'fabric.theme.red': '赤',
  'fabric.theme.subtle-blue': '淡い青',
  'fabric.theme.subtle-gray': '薄い灰色',
  'fabric.theme.subtle-green': '淡い緑',
  'fabric.theme.subtle-magenta': '薄いマゼンタ',
  'fabric.theme.subtle-orange': '薄いオレンジ',
  'fabric.theme.subtle-purple': '淡い紫',
  'fabric.theme.subtle-red': '淡い赤',
  'fabric.theme.subtle-teal': '淡い青緑',
  'fabric.theme.subtle-yellow': '淡い黄色',
  'fabric.theme.teal': '青緑',
  'fabric.theme.white': '白',
  'fabric.theme.yellow': '黄色',
  'fabrid.editor.rowNumbers': '行番号',
  'rovo.agents.dropdown.title': 'エージェント',
  'rovo.agents.dropdown.viewAgents.label': 'すべてのエージェントを表示',
};
